import { UrlManager } from '@skapiec/lib-url-manager';
import { useSelector } from '@ecommerce/nest-ssr/common';
import { useCallback, useMemo } from 'react';
import { CategoryStateInterface } from '../interfaces/category-state.interface';
import { CategoryUrlManagerInterface } from 'modules/categories/interfaces/category-url-manager.interface';
import { useCategoryUrlType } from 'modules/categories/interfaces/use-category-url.type';

export const useCategoryUrl = (): useCategoryUrlType => {
    const filters = useSelector((state: CategoryStateInterface) => state.category.filters);
    const params = useSelector((state: CategoryStateInterface) => state.categoryUrlParams);

    const maps = useMemo(() => {
        const map = new Map<string, [number, number]>();

        filters.groups.forEach(group => {
            group.entries.forEach(entry => {
                map.set(entry.id, [group.position, entry.position]);
            });
        });

        return map;
    }, [filters]);

    return useCallback((data?: Partial<CategoryUrlManagerInterface & { addFilters?: string[]; subFilters?: string[]; }>): string => {
        const filters: Record<number, number[]> = {};

        if (params?.filters?.length || data?.filters?.length || data?.addFilters?.length || data?.subFilters?.length) {
            let items: string[] = data?.filters ? [...data.filters] : [...params.filters ?? []];

            if (data?.addFilters) {
                items.push(...data.addFilters);
            }

            if (data?.subFilters) {
                items = items.filter(id => data?.subFilters?.includes(id) === false);
            }

            items.forEach(id => {
                const data = maps.get(id);

                if (data) {
                    if (filters[data[0]]) {
                        filters[data[0]].push(data[1]);
                    } else {
                        filters[data[0]] = [data[1]];
                    }
                }
            });
        }

        return UrlManager.category.view({ ...params, ...data, filters });
    }, [maps, params]);
};
